<template>
  <div class="deviceManagement">
    <!-- 批次号设备列表弹窗 -->
    <el-dialog
      title="批次查看"
      :visible.sync="mskflag"
      :fullscreen="true"
      center
      @close="batchDialogClose"
    >
      <div class="batch-info">
        <span class="info-title">批次编号:</span><span>{{ batchDialogId }}</span
        ><span class="info-title" style="padding-left: 100px">总设备数:</span
        ><span>{{ batchTotal }}台</span>
      </div>
      <div class="table">
        <el-table
          :data="batchTableData"
          empty-text="暂无数据"
          :border="true"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            prop="date"
            label="设备编码"
            width="220"
          >
            <template slot-scope="scope">
              <div
                :style="{
                  color: $jumpPerm('device_detail') ? '#165DFF' : '#606266',
                  cursor: 'pointer',
                }"
                @click="goDevDetail(scope.row._id)"
              >
                {{ scope.row._id || "-" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="设备型号">
            <template slot-scope="scope">
              {{ scope.row.code_name || "-" }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="固件版本">
            <template slot-scope="scope">
              {{ toDeviceVersion(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="订单类型">
            <template slot-scope="scope">
              {{
                scope.row.production_type === 1
                  ? "量产"
                  : scope.row.production_type === 2
                  ? "试产"
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="生产厂商">
            <template slot-scope="scope">
              {{ scope.row.manufacturer_name || "-" }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="语言">
            <template slot-scope="scope">
              {{
                scope.row.language === 1
                  ? "中文"
                  : scope.row.language === 2
                  ? "英文"
                  : "-"
              }}
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            :current-page="batchPage"
            layout="total,prev, pager, next"
            @current-change="currentChangefn"
            :total="batchTotal"
            :page-size="batchSize"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 设备新增弹窗 -->
    <el-dialog
      title="新增设备"
      :center="true"
      :close-on-click-modal="false"
      @close="clearAddForm"
      :visible.sync="addFlag"
      width="30%"
      top="20vh"
    >
      <el-form :model="addFormData" ref="addFormRef" label-width="80px">
        <el-form-item
          label="设备编码"
          prop="device_type"
          :rules="[{ required: true, message: '设备编码不能为空' }]"
        >
          <el-select
            size="small"
            v-model="addFormData.device_type"
            placeholder="请选择"
          >
            <el-option label="SN" :value="1"></el-option>
            <el-option label="IMEI" :value="2"></el-option>
            <el-option label="Mac" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="编码"
          prop="device_id"
          :rules="[{ required: true, message: '编码不能为空' }]"
        >
          <el-input
            size="small"
            placeholder="请输入编码"
            :validate-event="false"
            v-model="addFormData.device_id"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="设备型号"
          prop="code_id"
          :rules="[{ required: true, message: '设备型号不能为空' }]"
        >
          <el-select v-model="addFormData.code_id" size="mini">
            <el-option
              v-for="item in deviceNameList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="商户机构"
          prop="business_id"
          :rules="[{ required: true, message: '商户机构不能为空' }]"
        >
          <!-- v-removeAriaHidden 谷歌浏览器升级后会报错，添加removeAriaHidden防止报错 -->
          <el-cascader
            v-removeAriaHidden
            v-model="addFormData.business_id"
            :options="institutionList"
            :show-all-levels="false"
            filterable
            :props="{ checkStrictly: true, multiple: false }"
            clearable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 配置设备弹窗 -->
    <el-dialog
      title="配置设备"
      :center="true"
      :close-on-click-modal="false"
      @close="clearConfigureForm"
      :visible.sync="configureFlag"
      width="30%"
      top="20vh"
    >
      <el-form
        :model="configureFormData"
        ref="configureFormRef"
        label-width="80px"
      >
        <el-form-item label="设备编码" prop="_id">
          <el-input
            size="small"
            disabled
            v-model="configureFormData._id"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="分配商户"
          prop="business_id"
          :rules="[{ required: true, message: '商户不能为空' }]"
        >
          <el-cascader
            v-model="configureFormData.business_id"
            :options="institutionList"
            :show-all-levels="false"
            :props="{ checkStrictly: true }"
            clearable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="configureFlag = false">取 消</el-button>
        <el-button type="primary" @click="submitConfigure">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 批量导入弹窗 -->
    <el-dialog
      title="批量导入"
      :center="true"
      @close="clearImportDialog"
      :close-on-click-modal="false"
      :visible.sync="excelImportFlag"
      width="30%"
      top="20vh"
    >
      <div style="padding-bottom: 16px">
        你可以通过设备表单模版批量上传设备入库。<a
          :href="templateFileUrl"
          download="研和智能数据中心设备入库表.xlsx"
          style="color: #165dff"
          >下载模版</a
        >
      </div>
      <div v-if="uploadProgress === 'finish'" style="padding-bottom: 20px">
        <div style="padding-bottom: 16px">
          总设备数{{ totalDev }}，成功上传{{ success_count }}，错误设备数<span
            style="color: #f53f3f"
            >{{ fail_count }}</span
          >
        </div>
        <el-progress
          :text-inside="true"
          :stroke-width="24"
          :percentage="
            (
              ((this.success_count + this.fail_count) / this.totalDev) *
              100
            ).toFixed(0) * 1
          "
          status="success"
        ></el-progress>
        <div
          style="color: #f53f3f; cursor: pointer"
          v-if="this.file_url && fail_count > 0"
          @click="downloadFail"
        >
          下载错误数据
        </div>
      </div>
      <el-upload
        v-else
        class="upload"
        accept=".xls,.xlsx"
        drag
        action="#"
        :limit="1"
        :auto-upload="true"
        :http-request="upAndDowndoad"
        :before-upload="beforeUpload"
        :on-exceed="handleExceed"
        :file-list="fileList"
      >
        <div v-show="uploadProgress === 'before'">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件</div>
        </div>
      </el-upload>
    </el-dialog>
    <el-row :gutter="20" class="searchRow">
      <div class="searchForm">
        <el-col :span="22">
          <el-form
            size="mini"
            :model="searchForm"
            :inline="true"
            label-width="5vw"
          >
            <el-form-item>
              <!-- <el-form-item  > -->

              <el-input
                clearable
                size="mini"
                v-model="device_id"
                placeholder="请输入编号、sn号、IMEI、Mac地址"
                style="width: 17vw"
                @keyup.enter.native="filterData"
              >
                <el-select
                  v-model="device_type"
                  slot="prepend"
                  placeholder="请选择"
                  style="width: 6vw"
                >
                  <el-option label="全部" value="0"></el-option>
                  <el-option label="SN" value="1"></el-option>
                  <el-option label="IMEI" value="2"></el-option>
                  <el-option label="Mac地址" value="3"></el-option>
                </el-select>
              </el-input>

              <!-- </el-form-item> -->
            </el-form-item>

            <el-form-item label="设备型号">
              <el-select
                clearable
                v-model="searchForm.code_id"
                placeholder="全部"
                @keyup.enter.native="filterData"
                style="width: 12vw"
              >
                <el-option
                  v-for="item in deviceNameList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备类型">
              <el-select
                size="mini"
                filterable
                v-model="searchForm.device_class_id"
                clearable
                @keyup.enter.native="filterData"
                style="width: 12vw"
              >
                <el-option
                  v-for="item in deviceTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商户机构">
              <el-cascader
                v-model="searchForm.business_id"
                :options="institutionList"
                :show-all-levels="false"
                filterable
                @keyup.enter.native="filterData"
                style="width: 12vw"
                :props="{ checkStrictly: true, multiple: false }"
                clearable
              ></el-cascader>
            </el-form-item>
            <el-form-item label="绑定用户">
              <el-input
                clearable
                size="mini"
                v-model="searchForm.uid"
                placeholder="请输入"
                @keyup.enter.native="filterData"
                style="width: 12vw"
              ></el-input>
            </el-form-item>
            <el-form-item label="固件版本">
              <el-input
                clearable
                size="mini"
                v-model="searchForm.firmware_version"
                placeholder="请输入"
                @keyup.enter.native="filterData"
                style="width: 12vw"
              ></el-input>
            </el-form-item>
            <el-form-item label="批次号">
              <el-input
                clearable
                size="mini"
                v-model="searchForm.batch_number"
                placeholder="请输入"
                @keyup.enter.native="filterData"
                style="width: 12vw"
              ></el-input>
            </el-form-item>
            <el-form-item label="生产类型">
              <el-select
                size="mini"
                filterable
                v-model="searchForm.production_type"
                @keyup.enter.native="filterData"
                clearable
                style="width: 12vw"
              >
                <el-option
                  v-for="item in productTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生产厂商">
              <el-select
                size="mini"
                filterable
                v-model="searchForm.manufacturer_id"
                @keyup.enter.native="filterData"
                clearable
                style="width: 12vw"
              >
                <el-option
                  v-for="item in productNameList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="语言">
              <el-select
                size="mini"
                filterable
                v-model="searchForm.language"
                @keyup.enter.native="filterData"
                clearable
                style="width: 12vw"
              >
                <el-option
                  v-for="item in languageList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保修">
              <el-select
                size="mini"
                @keyup.enter.native="filterData"
                filterable
                v-model="searchForm.warranty_status"
                clearable
                style="width: 12vw"
              >
                <el-option
                  v-for="item in statelist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备状态">
              <el-select
                size="mini"
                filterable
                @keyup.enter.native="filterData"
                v-model="searchForm.status"
                clearable
                style="width: 12vw"
              >
                <el-option
                  v-for="item in deviceStatuList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="首次绑定">
              <el-date-picker
                v-model="bindTime"
                type="daterange"
                :value-format="searchValFormat"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 12vw"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="入库时间">
              <el-date-picker
                v-model="putTime"
                type="daterange"
                :value-format="searchValFormat"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 12vw"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="2" class="searchbuttons">
          <div>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-search"
              @click="filterData"
              >查询</el-button
            >
          </div>
          <div class="searchButton">
            <el-button
              type="info"
              size="mini"
              icon="el-icon-refresh-right"
              @click="reset"
              >重置</el-button
            >
          </div>
        </el-col>
        <!-- <div class="toggle">展开<span></span></div> -->
      </div>
    </el-row>
    <div class="buttons">
      <div class="leftButton">
        <el-button
          v-permission="'dev_add'"
          type="primary"
          size="mini"
          icon="el-icon-plus"
          @click="addFlag = true"
          >添加</el-button
        >
        <el-button
          v-permission="'dev_import'"
          type="primary"
          size="mini"
          @click="excelImportFlag = true"
          >批量导入</el-button
        >
      </div>
      <div class="rightButton">
        <el-button
          v-permission="'dev_download'"
          type="info"
          size="mini"
          icon="el-icon-download"
          @click="downloadExcel"
          >下载</el-button
        >
      </div>
    </div>
    <el-table
      v-loading="loading"
      empty-text="暂无数据"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column align="center" label="设备编码" width="220">
        <template slot-scope="scope">
          <div
            :style="{
              color: $jumpPerm('device_detail') ? '#165DFF' : '#606266',
              cursor: 'pointer',
            }"
            @click="goDevDetail(scope.row._id)"
          >
            {{ scope.row.coding || scope.row._id || "-" }}
          </div>
          <!-- <el-button type="text" @click="goDevDetail(scope.row._id)">{{
            scope.row.coding || scope.row._id || "-"
          }}</el-button> -->
        </template>
      </el-table-column>
      <el-table-column align="center" label="设备型号" width="120">
        <template slot-scope="scope">
          {{ scope.row.code_name || "-" }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="SN" width="160">
        <template slot-scope="scope">
          {{ scope.row.sn || "-" }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="IMEI" width="160">
        <template slot-scope="scope">
          {{ scope.row.imei || "-" }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="Mac地址" width="160">
        <template slot-scope="scope">
          {{ scope.row.mac || "-" }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="设备类型" width="120">
        <template slot-scope="scope">
          {{ scope.row.device_class_name || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="商户名称"
        width="150"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.business_name || "-" }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="机构名称" width="120">
        <template slot-scope="scope">
          {{ scope.row.institution_name || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        align="center"
        label="绑定用户"
        width="220"
      >
        <template slot-scope="scope">
          <!-- <div v-if="scope.row.uid.length">
            <el-button
              v-for="(item, index) in scope.row.uid"
              :key="index"
              type="text"
              @click="goUserDetail(scope.row, index)"
              >{{ item }}</el-button
            >
          </div> -->
          <el-popover
            v-if="scope.row.bindUsers.length"
            trigger="hover"
            placement="top"
          >
            <div v-if="scope.row.bindUsers.length">
              <el-button
                v-for="(item, index) in scope.row.bindUsers"
                :key="index"
                type="text"
                @click="goUserDetail(scope.row, index)"
                >{{ item.name }}</el-button
              >
            </div>
            <div slot="reference">
              <!-- <span
                style="
                    display: -webkit-box;;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    white-space: pre-line;
                    "
              >
                {{ scope.row.user_info }}
              </span> -->
              <div
                v-if="scope.row.bindUsers.length"
                style="
                  display: -webkit-box;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                  white-space: pre-line;
                "
              >
                <el-button
                  v-for="(item, index) in scope.row.bindUsers"
                  :key="index"
                  type="text"
                  @click="goUserDetail(scope.row, index)"
                  >{{ item.name }}</el-button
                >
              </div>
            </div>
          </el-popover>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="首次绑定日期" width="170">
        <template slot-scope="scope">
          {{ scope.row.first_bind_time || "-" }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="固件版本" width="160">
        <template slot-scope="scope">
          {{ toDeviceVersion(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="批次号" width="120">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.batch_number"
            type="text"
            @click="getBatchTable(scope.row.batch_number)"
            >{{ scope.row.batch_number }}</el-button
          >
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="生产类型" width="120">
        <template slot-scope="scope">
          {{
            scope.row.production_type === 1
              ? "量产"
              : scope.row.production_type === 2
              ? "试产"
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="生产厂商"
        width="150"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.manufacturer_name || "-" }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="语言" width="120">
        <template slot-scope="scope">
          {{
            scope.row.language === 1
              ? "中文"
              : scope.row.language === 2
              ? "英文"
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="保修" width="100">
        <template slot-scope="scope">
          {{ scope.row.warranty }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="入库日期" width="170">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态" width="120">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            @change="handleStatuChange(scope.row._id, scope.row.status)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            v-permission="'dev_config'"
            type="text"
            @click="configure(scope.row)"
            >配置</el-button
          >
          <el-button
            v-permission="'dev_del'"
            type="text"
            @click="delDev(scope.row._id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        @current-change="changepagefn"
        :page-size="size"
        :current-page="page"
        layout="->,total,prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  handtime,
  transformKeys,
  exportToExcel,
  tableDataTransform,
} from "@/utils/util";
import { API_URL } from "@/api/request";
import {
  DeviceLists,
  deviceAdd,
  deviceConfigure,
  institutionTreeList,
  importDevice,
} from "@/api/device.js";
import { handleResponse } from "@/utils/response";
export default {
  name: "deviceManagement",
  data() {
    return {
      addFlag: false,
      configureFlag: false,
      excelImportFlag: false,
      mskflag: false,
      templateFileUrl: "",
      fileList: [],
      uploadProgress: "before",
      totalDev: "",
      success_count: "",
      fail_count: "",
      file_url: "",
      addFormData: {
        device_type: "",
        device_id: "",
        code_id: "",
        business_id: "",
      },
      configureFormData: {
        _id: "",
        business_id: "",
      },
      page: 1,
      loading: false,
      // 搜索条件表单
      searchForm: {
        code_id: "",
        device_class_id: "",
        business_id: "",
        uid: "",
        firmware_version: "",
        batch_number: "",
        production_type: "",
        manufacturer_id: "",
        language: "",
        warranty_status: "",
        status: "",
        bind_time: "",
        put_time: "",
      },
      bindTime: "",
      putTime: "",
      device_type: "0",
      device_id: "",
      searchValFormat: "yyyy-MM-dd",
      state: "",
      size: 10,
      total: 0,
      deviceNameList: [],
      tableData: [],
      totalTableData: [],
      batchDialogId: "",
      batchTableData: [],
      batchPage: 1,
      batchSize: 10,
      batchTotal: 0,
      statelist: [
        {
          key: 1,
          value: 1,
          label: "在保",
        },
        {
          key: 2,
          value: 2,
          label: "过保",
        },
      ],
      deviceTypeList: [],
      productNameList: [],
      institutionTypeList: [],
      productTypeList: [
        {
          value: 1,
          label: "量产",
        },
        {
          value: 2,
          label: "试产",
        },
      ],
      languageList: [
        {
          value: 1,
          label: "中文",
        },
        {
          value: 2,
          label: "英文",
        },
      ],
      deviceStatuList: [
        {
          value: 1,
          label: "启用",
        },
        {
          value: 2,
          label: "停用",
        },
      ],
      institutionList: [],
    };
  },
  async created() {
    // 获取模版链接地址
    this.templateFileUrl =
      API_URL + "/download/研和智能数据中心设备入库表.xlsx";
    // 获取设备型号的选项列表
    this.deviceNameList = JSON.parse(localStorage.getItem("deviceName"));
    // 获取设备类型的选项列表
    this.deviceTypeList = JSON.parse(localStorage.getItem("deviceType"));
    // 获取生产厂商的选项列表
    this.productNameList = JSON.parse(localStorage.getItem("productName"));
    // 获取商户类型的选项列表
    this.institutionTypeList = JSON.parse(
      localStorage.getItem("institutionType")
    );
    this.DeviceListsfn();
    this.getInstitutionList();
  },
  mounted() {},
  computed: {
    //查看设备详情权限管理
    deviceDetailFlag() {
      return (
        this.$store.state.userInfo.permissions.includes("deviceDetail") ||
        this.$store.getters.isAdmin
      );
    },
    importFlag() {
      return (
        this.$store.state.userInfo.permissions.includes("deviceImport") ||
        this.$store.getters.isAdmin
      );
    },
  },
  filters: {
    handtime,
  },
  methods: {
    // 格式化日期格式
    formatDate(dataRage) {
      if (Array.isArray(dataRage)) {
        const start = dataRage[0] + " 00:00:00";
        const end = dataRage[1] + " 23:59:59";
        return `${start}~${end}`;
      }
      return "";
    },

    toDeviceVersion(row) {
      const { firmware_version, deviceVersion, code_name } = row;

      let devVersion = deviceVersion;
      if (devVersion) {
        if (code_name === "Y006") {
          if (devVersion.length > 8) {
            devVersion = (devVersion * 1).toString(16);
          }
          devVersion = ("00000000" + devVersion)
            .substr(-8)
            .split("")
            .map((s, i) => (i == 0 ? "00" + s : i == 1 || i == 3 ? "0" + s : s))
            .join("")
            .match(new RegExp(".{1,3}", "g"))
            .map((s) => parseInt("0x" + s))
            .join(".");
        } else if (code_name === "Y001S") {
          devVersion = ("00000000" + devVersion)
            .substr(-8)
            .match(new RegExp(".{1,2}", "g"))
            .map((s) => parseInt("0x" + s))
            .join(".");
        }
      }

      if (firmware_version && devVersion) {
        return `${firmware_version} > ${devVersion}`;
      }

      return firmware_version || devVersion || "-";
    },

    // 获取商户-机构级联选择菜单
    async getInstitutionList() {
      const { data } = await institutionTreeList();
      if (data.code === 1000) {
        this.institutionList = transformKeys(data.data.data);
      } else {
        this.$message.error(data.msg);
      }
    },
    // 查看批次号设备列表
    async getBatchTable(id) {
      this.mskflag = true;
      this.batchDialogId = id;
      const { data } = await DeviceLists({
        page: this.batchPage,
        size: this.batchSize,
        batch_number: id,
      });
      if (data.code === 1000) {
        this.batchTableData = data.data.list;
        this.batchTotal = data.data.count;
      } else {
        this.$message.error(data.msg);
      }
    },
    // 切换批次号弹窗表格页码值
    currentChangefn(index) {
      this.batchPage = index;
      this.getBatchTable(this.batchDialogId);
    },
    // 批次号弹窗关闭
    batchDialogClose() {
      this.batchPage = 1;
    },
    // 状态改变
    async handleStatuChange(id, status) {
      const { data } = await deviceConfigure({
        _id: id,
        status: status ? 1 : 2,
      });
      if (data.code === 1000) {
        this.DeviceListsfn();
      } else {
        this.$message.error(data.msg);
      }
    },
    // 配置按钮
    configure(row) {
      this.configureFlag = true;
      this.configureFormData._id = row._id;
      this.configureFormData.business_id = row.business_id;
    },
    // 删除设备
    delDev(id) {
      this.$post(`/device/del?gdid=${id}`).then((r) => {
        if (r.data.code === 1000) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.DeviceListsfn();
        } else {
          this.$message({
            type: "error",
            message: `删除失败,${r.data.msg}`,
          });
        }
      });
    },
    // 提交新增设备
    submitAdd() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (valid) {
          if (this.addFormData.business_id !== "") {
            const length = this.addFormData.business_id.length;
            this.addFormData.business_id =
              this.addFormData.business_id[length - 1];
          }

          const { data } = await deviceAdd({
            ...this.addFormData,
          });
          console.log(data);
          if (data.code === 1000) {
            this.addFlag = false;
            this.DeviceListsfn();
          } else {
            this.$message.error(data.msg);
          }
        }
      });
    },
    // 提交配置设备
    submitConfigure() {
      this.$refs.configureFormRef.validate(async (valid) => {
        if (valid) {
          const length = this.configureFormData.business_id.length;
          const { data } = await deviceConfigure({
            _id: this.configureFormData._id,
            business_id: this.configureFormData.business_id[length - 1],
          });
          if (data.code === 1000) {
            this.configureFlag = false;
            this.DeviceListsfn();
          } else {
            this.$message.error(data.msg);
          }
        }
      });
    },
    // 关闭新增设备弹窗
    clearAddForm() {
      this.$refs.addFormRef.resetFields();
      this.addFormData = {
        device_type: "",
        device_id: "",
        code_id: "",
        business_id: "",
      };
    },
    clearConfigureForm() {},
    changepagefn(index) {
      this.page = index;
      this.DeviceListsfn();
    },
    // 获取表格数据
    async DeviceListsfn() {
      this.searchForm.bind_time = this.formatDate(this.bindTime);
      this.searchForm.put_time = this.formatDate(this.putTime);
      if (
        this.searchForm.business_id &&
        Array.isArray(this.searchForm.business_id)
      ) {
        const length = this.searchForm.business_id.length;
        this.searchForm.business_id = this.searchForm.business_id[length - 1];
      } else if (this.searchForm.business_id === "") {
        delete this.searchForm.business_id;
      }
      switch (this.device_type) {
        case "0":
          this.searchForm.all_encode = this.device_id;
          delete this.searchForm.sn;
          delete this.searchForm.imei;
          delete this.searchForm.mac;
          break;
        case "1":
          this.searchForm.sn = this.device_id;
          delete this.searchForm.all_encode;
          delete this.searchForm.imei;
          delete this.searchForm.mac;
          break;
        case "2":
          this.searchForm.imei = this.device_id;
          delete this.searchForm.all_encode;
          delete this.searchForm.sn;
          delete this.searchForm.mac;
          break;
        case "3":
          this.searchForm.mac = this.device_id;
          delete this.searchForm.all_encode;
          delete this.searchForm.imei;
          delete this.searchForm.sn;
          break;
        default:
          break;
      }
      this.loading = true;
      const ret = await DeviceLists({
        ...this.searchForm,
        page: this.page,
        size: this.size,
      });
      this.loading = false;
      this.tableData = ret.data.data.list;
      this.total = ret.data.data.count;
      this.tableData &&
        this.tableData.forEach(
          (item) => (item.status = item.status === 1 ? true : false)
        );
    },
    // 搜索表格数据
    filterData() {
      this.page = 1;
      this.DeviceListsfn();
    },
    // 重置
    reset() {
      this.searchForm = {
        code_id: "",
        device_class_id: "",
        business_name: "",
        uid: "",
        firmware_version: "",
        batch_number: "",
        production_type: "",
        manufacturer_id: "",
        language: "",
        warranty_status: "",
        status: "",
        bind_time: "",
        put_time: "",
      };
      this.device_id = "";
      this.device_type = "0";
      this.bindTime = "";
      this.putTime = "";
      this.page = 1;
      this.DeviceListsfn();
    },
    // 查看设备详情
    goDevDetail(id) {
      if (this.$jumpPerm("device_detail")) {
        this.mskflag = false;
        this.$router.push({
          path: "/devDetail",
          query: {
            id: id,
          },
        });
      }
    },
    // 跳转用户详情
    goUserDetail(row, index) {
      console.log(row, index);
      if (this.$jumpPerm("user_detail")) {
        this.$router.push({
          path: "/userDetail",
          query: {
            id: row.bindUsers[index].id,
            tabs: "first",
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
      // this.$router.push({
      //   path: "/userDetail",
      //   query: {
      //     id: row.bindUsers[index].id,
      //     tabs: "first",
      //   },
      // });
    },

    getProgress() {
      if (!this.progressUuid) {
        return;
      }
      let form = new FormData();
      form.append("uuid", this.progressUuid);
      importDevice(form).then((response) => {
        handleResponse(
          response,
          (data) => {
            this.totalDev = data.data.total;
            this.success_count = data.data.success_count;
            this.fail_count = data.data.fail_count;
            if (data.data.file_url) {
              this.file_url = API_URL + data.data.file_url;
            } else {
              this.file_url = "";
            }
            if (data.data.status != 1) {
              setTimeout(() => {
                this.getProgress();
              }, 1000);
            }
          },
          (error) => {}
        );
      });
    },

    // 批量导入
    async upAndDowndoad(params) {
      console.log(params.file);
      let form = new FormData();
      form.append("file", params.file);
      const { data } = await importDevice(form);
      if (data.code === 1000) {
        this.uploadProgress = "finish";
        this.totalDev = data.data.data.total;
        this.success_count = data.data.data.success_count;
        this.fail_count = data.data.data.fail_count;
        if (data.data.data.file_url) {
          this.file_url = API_URL + data.data.data.file_url;
        } else {
          this.file_url = "";
        }
        this.progressUuid = data.data.data.uuid;
        this.getProgress();
      } else {
        this.$message.error(data.msg);
      }
    },
    // 上传前校验
    beforeUpload(file) {
      let legalName = ["xlsx", "xls"];
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (legalName.includes(name)) {
        // console.log(legalName.includes(name));
      } else {
        this.$message.warning("文件格式不对，仅限xls和xlsx");
        return false;
      }
    },
    // 限制文件个数
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    // 下载失败数据
    downloadFail() {
      this.excelImportFlag = false;

      const fileURL = this.file_url;
      // 创建一个隐藏的链接
      const link = document.createElement("a");
      link.style.display = "none";
      document.body.appendChild(link);
      // 设置链接的 URL
      link.href = fileURL;
      // 模拟点击链接以下载文件
      link.click();
      // 移除链接元素
      document.body.removeChild(link);
    },
    // 导入设备弹窗关闭
    clearImportDialog() {
      this.uploadProgress = "before";
      this.progressUuid = "";
    },
    // excel表格导出
    async downloadExcel() {
      const { data } = await DeviceLists({
        ...this.searchForm,
        page: 1,
        size: 10000,
      });
      this.totalTableData = data.data.list;
      this.totalTableData &&
        this.totalTableData.forEach(
          (item) => (item.status = item.status === 1 ? true : false)
        );

      const tableData = tableDataTransform(this.totalTableData);
      console.log(tableData);
      exportToExcel(tableData, "example");
    },
  },
};
</script>

<style lang="less">
.deviceManagement {
  background-color: #fff;
  .page {
    padding-top: 20px;
  }
  padding: 20px;
  .blue {
    display: block;
    color: #409eff;
    cursor: pointer;
  }
}
.searchRow {
  // height: 90px;
  // overflow: hidden;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
}
.searchForm {
  height: 100%;
}
.searchButton {
  padding-top: 20px;
  padding-bottom: 20px;
}
.buttons {
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.el-select,
.el-cascader {
  padding-right: 0px;
}
.batch-info {
  padding-bottom: 28px;
  .info-title {
    padding-right: 12px;
    color: #86909c;
  }
}
.el-switch.is-checked .el-switch__core {
  border-color: #165dff !important;
  background-color: #165dff !important;
}
</style>
